<kendo-dialog title="Session Expiring" *ngIf="showModal" (close)="stayLoggedIn()">

  <nexus-card-body>
    <div class="d-flex justify-content-center mt-3 width-250px">Your session will expire in {{ countdown | sbTimeFormat }}</div>
  </nexus-card-body>
  <kendo-dialog-actions>
    <div class="d-flex justify-content-end">
      <button kendoButton (click)="stayLoggedIn()" [primary]="true">Stay Logged In</button>
    </div>
  </kendo-dialog-actions>
</kendo-dialog>
